import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowRight, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const sujets = [
  "Demande d'information",
  "Entretien régulier du jardin",
  "Taille de haies / élagage",
  "Création ou aménagement",
  "Nettoyage extérieur",
  "Autre demande",
];

const initial = { nom: "", email: "", telephone: "", sujet: "", message: "" };

export default function ContactForm() {
  const [form, setForm] = useState(initial);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      setDone(true);
    } catch {
      toast.error("Une erreur est survenue. Merci de réessayer.");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div data-testid="contact-form-success" className="h-full flex flex-col items-center justify-center text-center bg-white rounded-3xl border border-forest/10 shadow-xl shadow-forest/5 p-10">
        <div className="w-14 h-14 rounded-full bg-forest/10 flex items-center justify-center">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4A7C59" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
        </div>
        <h3 className="mt-5 font-serif text-2xl text-forest">Message envoyé !</h3>
        <p className="mt-2 text-sm text-coal-muted leading-relaxed max-w-sm">
          Merci pour votre message. Nous vous répondrons dans les meilleurs délais.
        </p>
        <button onClick={() => { setDone(false); setForm(initial); }} className="btn-outline-forest mt-7" data-testid="contact-form-reset-button">
          Envoyer un autre message
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="contact-form" className="bg-white rounded-3xl border border-forest/10 shadow-xl shadow-forest/5 p-6 sm:p-9 space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="c-nom" className="block text-[13px] font-semibold text-forest mb-1.5">Nom *</label>
          <input id="c-nom" required data-testid="contact-form-input-nom" className="field" value={form.nom} onChange={set("nom")} placeholder="Votre nom" />
        </div>
        <div>
          <label htmlFor="c-tel" className="block text-[13px] font-semibold text-forest mb-1.5">Téléphone</label>
          <input id="c-tel" type="tel" data-testid="contact-form-input-telephone" className="field" value={form.telephone} onChange={set("telephone")} placeholder="0470 12 34 56" />
        </div>
      </div>
      <div>
        <label htmlFor="c-email" className="block text-[13px] font-semibold text-forest mb-1.5">E-mail *</label>
        <input id="c-email" required type="email" data-testid="contact-form-input-email" className="field" value={form.email} onChange={set("email")} placeholder="vous@exemple.be" />
      </div>
      <div>
        <label htmlFor="c-sujet" className="block text-[13px] font-semibold text-forest mb-1.5">Sujet *</label>
        <select id="c-sujet" required data-testid="contact-form-input-sujet" className="field" value={form.sujet} onChange={set("sujet")}>
          <option value="" disabled>Choisir un sujet…</option>
          {sujets.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="c-message" className="block text-[13px] font-semibold text-forest mb-1.5">Message *</label>
        <textarea id="c-message" required rows={5} data-testid="contact-form-input-message" className="field resize-none" value={form.message} onChange={set("message")} placeholder="Votre message…" />
      </div>
      <button type="submit" disabled={sending} data-testid="contact-form-submit" className="btn-primary w-full disabled:opacity-60 disabled:pointer-events-none">
        {sending ? (
          <>
            <Loader2 size={16} className="animate-spin" /> Envoi en cours…
          </>
        ) : (
          <>
            Envoyer le message <ArrowRight size={15} />
          </>
        )}
      </button>
      <p className="flex items-center justify-center gap-1.5 text-[11px] text-coal/45">
        <ShieldCheck size={13} className="text-moss" /> Vos informations restent confidentielles
      </p>
    </form>
  );
}
